import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class PropulsionRolloutService {
  constructor(private http: HttpClient) {}

  public getPropulsionReportData(
    propulsion: string[],
    oem: string[],
    brand: string[],
    region: string[],
    architecture: string[],
    bodyStyle: string[],
    segment: string[],
    status: string[],
    year: string
  ): Observable<any> {
    const url = environment.serviceURL + "/propulsionReportData";
    return this.http.post<any>(url, {
      propulsionType: propulsion,
      oem,
      brand,
      region,
      architecture,
      bodyStyle,
      segment,
      status,
      year,
    });
  }

  public getAPLReportMenuOptions(): Observable<any> {
    const url =
      environment.serviceURL + "/propulsionReportMenuItems";
    return this.http.get<any>(url);
  }

  public exportToExcel(
    propulsion: string[],
    oem: string[],
    brand: string[],
    region: string[],
    architecture: string[],
    bodyStyle: string[],
    segment: string[],
    status: string[],
    year: string
  ): Observable<Blob> {
    const url =
      environment.serviceURL + "/propulsionReportExportToExcel";
    const headers = new HttpHeaders();
    headers["Content-Disposition"] = "attachment; filename=filename.pdf";
    return this.http.post(
      url,
      {
        propulsionType: propulsion,
        oem,
        brand,
        architecture,
        bodyStyle,
        segment,
        status,
        region,
        year,
      },
      { headers, responseType: "blob" }
    );
  }
}
